var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#82ACF5",
    fillOpacity: 0.46
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_519_2752",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 28,
    height: 28
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 28,
    height: 28,
    fill: "#1C1B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_519_2752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 42.5C30.8 41.3667 29.425 40.5 27.875 39.9C26.325 39.3 24.7 39 23 39V28C24.6833 28 26.3 28.304 27.85 28.912C29.4 29.5207 30.7833 30.4 32 31.55C33.2167 30.4 34.6 29.5207 36.15 28.912C37.7 28.304 39.3167 28 41 28V39C39.2833 39 37.6543 39.3 36.113 39.9C34.571 40.5 33.2 41.3667 32 42.5ZM32 39.9C33.05 39.1167 34.1667 38.4917 35.35 38.025C36.5333 37.5583 37.75 37.25 39 37.1V30.2C37.7833 30.4167 36.5877 30.854 35.413 31.512C34.2377 32.1707 33.1 33.05 32 34.15C30.9 33.05 29.7627 32.1707 28.588 31.512C27.4127 30.854 26.2167 30.4167 25 30.2V37.1C26.25 37.25 27.4667 37.5583 28.65 38.025C29.8333 38.4917 30.95 39.1167 32 39.9ZM32 29C30.9 29 29.9583 28.6083 29.175 27.825C28.3917 27.0417 28 26.1 28 25C28 23.9 28.3917 22.9583 29.175 22.175C29.9583 21.3917 30.9 21 32 21C33.1 21 34.0417 21.3917 34.825 22.175C35.6083 22.9583 36 23.9 36 25C36 26.1 35.6083 27.0417 34.825 27.825C34.0417 28.6083 33.1 29 32 29ZM32 27C32.55 27 33.021 26.804 33.413 26.412C33.8043 26.0207 34 25.55 34 25C34 24.45 33.8043 23.979 33.413 23.587C33.021 23.1957 32.55 23 32 23C31.45 23 30.9793 23.1957 30.588 23.587C30.196 23.979 30 24.45 30 25C30 25.55 30.196 26.0207 30.588 26.412C30.9793 26.804 31.45 27 32 27Z",
    fill: "#82ACF5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdd);
export default __webpack_public_path__ + "static/media/odd.0250c1dae26bb19c9a713f6a7e6f2bcb.svg";
export { ForwardRef as ReactComponent };